/**
 * @file Discover Album Folder Navigation component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '../global/Button';
import withModal from '../global/modal/withModal';
import { DISCOVER_REQUEST_MODAL } from '../../constants/modals';
import { getAsset } from '../../util/assets';
import FormGroup from '../global/FormGroup';
import { getAccountCheckoutGreetingName } from '../../util/account';

class DiscoverAlbumFolderRequestAlbumModal extends Component {
  static propTypes = {
    onRequestClose: PropTypes.func,
    albumFolder: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
    }),
  };

  state = {
    request: '',
  };

  onRequestChange = event => {
    const { value } = event.target;
    this.setState(() => ({
      request: value,
    }));
  };

  render() {
    const { onRequestClose, albumFolder } = this.props;

    const { request } = this.state;

    const subject = encodeURIComponent(
      `Request new activity for Gallery: ${albumFolder.name} (ID: ${albumFolder.id})`,
    );
    const body = encodeURIComponent(
      `Could you guys add '${request}' to '${albumFolder.name}'` +
        `by ${getAccountCheckoutGreetingName(albumFolder.account)})`,
    );
    const link = `mailto:info@waldophotos.com?subject=${subject}&body=${body}`;

    return (
      <div className="d-flex flex-column">
        <img
          src={getAsset('/waldo-icon.svg')}
          alt="Waldo icon"
          width="70px"
          className="m-auto"
        />
        <p className="mt-1 text-dark text-bold text-center mb-0">
          Didn&rsquo;t find what you&rsquo;re looking for?
        </p>
        <p className="text-center mb-2">
          No problem! Let us know what we should add next
        </p>
        <form>
          <FormGroup
            id="request"
            type="text"
            label="What should Waldo add?"
            name="request"
            onChange={this.onRequestChange}
            required
          />
        </form>
        <Button width="70px" href={link} disabled={request.length === 0}>
          Submit Request
        </Button>
        <Button
          btnBlock
          btnStyle="link"
          className="text-center mt-2"
          onClick={() => {
            onRequestClose();
          }}
        >
          Close
        </Button>
      </div>
    );
  }
}

export default withModal(DiscoverAlbumFolderRequestAlbumModal, {
  name: DISCOVER_REQUEST_MODAL,
  size: 'sm',
  dismissible: true,
  contentLabel: 'Request new listing',
});
